import { render, staticRenderFns } from "./SugeridoCell.vue?vue&type=template&id=010ccd4b&scoped=true"
import script from "./SugeridoCell.vue?vue&type=script&lang=js"
export * from "./SugeridoCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010ccd4b",
  null
  
)

export default component.exports